import { IEnvironment } from './environment-base';

export const environment: IEnvironment = {
  production: true,
  site_base: 'https://app.vivesec.com',
  url_api: 'https://app.vivesec.com/api',
  url_ws: 'wss://app.vivesec.com/api/ws',
  url_sws: 'wss://app.vivesec.com/api/sws',
  url_landing: 'https://vivesecbox.com',
  url_office_editor: 'https://doc.vivesec.com',
  url_legal: 'https://vivesecbox.com/documents',
  url_ai_box: 'https://aiui.vivesec.com',
  beta: false,
  cookie_url: 'app.vivesec.com',
  ws_timeout: 25000,

  live_muc_version_url: '/muc-client/version.json',
  live_jitsi_lib_fallback_url: '/muc-client/latest/lib-jitsi-meet.min.js',
  get_live_jitsi_lib_url: (version) => {
    return 'https://app.vivesec.com/muc-client/' + version + '/lib-jitsi-meet.min.js';
  },

  sites_migrated: ['https://nano.clarabot.com'],
  support_email: 'info@vivetech.com',
};
